import React, { useState, useEffect } from 'react';
import { Card, Col, Form, Row, Button } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import axios from 'helpers/api';
import { toast } from 'react-toastify';
import { createIframeReportBlobUrl } from 'helpers/iframeReportPreview';
import AdvanceTablePagination from 'components/common/advance-table/AdvanceTablePagination';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import Spinner from 'react-bootstrap/Spinner';
import Select from "react-select";
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import moment from 'moment';

const columns = [
    {
        accessorKey: 'month',
        header: 'Report Date',
        meta: {
            headerProps: { className: 'text-900 text-start' },
            cellProps: { className: 'text-start' }
        }
    },
    {
        accessorKey: 'download',
        header: 'Report Download',
        meta: {
            headerProps: { className: 'text-900 text-start' },
            cellProps: { className: 'text-start' }
        }
    }
];

//const [medsheet, setMedSheet] = useState([]);


const HcpOrder = ({ onCallParent, data }) => {

    const [hcporderrpt, setHcpOrder] = useState("");
    const [hcpoptions, setHcpOptions] = useState([]);
    const [allHcpOptions, setAllHcpOptions] = useState([]);
    const [spinner, showSpinner] = useState(false);
    const [hcpError, setHcpError] = useState(false);
    const [reportFormatError, setReportFormatError] = useState(false);
    const [reasonError, setReasonError] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [formData, setFormData] = useState({
        hcp: '',
        reportformat: Number(localStorage.getItem("groupId")) == 52 ? '9' : '',
        hcpAddress: '',
        appointmentDate: null,
        appointmentTime: '',
        isAnnualPhysical: '',
        reason: '',
        isShowAllHCP: false
    });
    const { programId } = useParams();

    const [reportdate, setReportDate] = useState(null);
    const [showResults, setShowResults] = React.useState(false)
    let reportFormatOptions = [
        { value: '', label: 'Select your Format' },
        { value: '1', label: 'HCP Order Default Template' },
        // { value: '2', label: 'HCP ACETAMINOPHEN' },
        // { value: '3', label: 'HCP Standard' },
        // { value: '4', label: 'HCP Bowel' },
        // { value: '5', label: 'HCP Diet' },
    ];

    if (Number(localStorage.getItem("groupId")) == 52) {
        reportFormatOptions.push({ value: '9', label: 'HCP Delta HCP Order Form' });
    } else if (Number(localStorage.getItem("groupId")) == 61) {
        reportFormatOptions.push({ value: '10', label: 'HCP Incompass Order Form' });
    }else if (Number(localStorage.getItem("groupId")) == 3115) {
        reportFormatOptions.push({ value: '11', label: 'HCP OFI Order Form' });
    }

    // const [hcpoptions, setHcpOptions] = useState([]);
    useEffect(() => {
        if (spinner) {
            setShowResults(false);
        }
    }, [spinner])


    useEffect(() => {
        fetchHcpData();
        const uniqueDoctors = new Set();
        const doctorOptions = [];

        // For medical_records: active if is_active == 1
        (data?.medical_records || []).forEach((prescription) => {
            const doctorFullName = `${prescription.doctor_lastname}, ${prescription.doctor_firstname}`;
            const doctorId = prescription.doctor_id;

            if (prescription.is_active == 1 && !uniqueDoctors.has(doctorId) && (prescription.doctor_lastname != null && prescription.doctor_firstname != null)) {
                uniqueDoctors.add(doctorId);
                doctorOptions.push({ key: doctorFullName, value: doctorId });
            }
        });

        // For prescriptions: active if discontinued_date == null
        (data?.prescriptions || []).forEach((prescription) => {
            const doctorFullName = `${prescription.doctor_lastname}, ${prescription.doctor_firstname}`;
            const doctorId = prescription.doctor_id;

            if (prescription.discontinued_date == null && !uniqueDoctors.has(doctorId) && (prescription.doctor_lastname != null && prescription.doctor_firstname != null)) {
                uniqueDoctors.add(doctorId);
                doctorOptions.push({ key: doctorFullName, value: doctorId });
            }
        });
        setHcpOptions(doctorOptions);

    }, [data.prescriptions]);

    async function fetchHcpData() {

        let tokenStr = localStorage.getItem("accessToken");
        //TODO confirm with SHANKS whether listing is based on facility id or not
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/doctors/list-doctors", { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        let results = []

        //console.log("Doctor Data Status " + data.status);
        let objPatientData = data.data;

        objPatientData.forEach((value) => {
            if (value.firstname != null && value.lastname != null) {
                results.push({
                    key: value.lastname + ", " + value.firstname,
                    value: value.id
                });
            }
        });

        setAllHcpOptions([
            ...results
        ])
    }
    // Handler
    const handleSubmit = async e => {
        e.preventDefault();
        const isHcpValid = formData.hcp !== '';
        const isReportFormatValid = formData.reportformat !== '';
        // const isreasonValid = formData.reason !== '';
        const formattedDate = formData.appointmentDate
            ? moment(formData.appointmentDate).format("MM/DD/YYYY")
            : "";

        const formattedTime = formData.appointmentTime || "";
        setHcpError(!isHcpValid);
        setReportFormatError(!isReportFormatValid);
        // setReasonError(!isreasonValid);


        if (!isHcpValid || !isReportFormatValid) {
            return;
        }
        if ((localStorage.getItem("patientId") != null || localStorage.getItem("reportFacilityId") != null) && formData.reportformat != "" && formData.hcp != "") {

            showSpinner(true);

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsHcpOrderUrl = `${process.env.REACT_APP_SERVER_URL}` + "/reports/hcporder-exp";

            let pelmedsHcpOrderData =
            {
                hcp: formData.hcp,
                patient_id: localStorage.getItem("patientId"),
                hcp_order_format: formData.reportformat,
                reason: formData.reason,
                appointment_date: formattedDate,
                appointment_time: formattedTime,
                is_annual: formData.isAnnualPhysical === true ? 1 : formData.isAnnualPhysical === false ? 2 : 3,
                hcp_address: formData.hcpAddress
            };

            if (programId) {
                pelmedsHcpOrderData.day_program_id = programId;
            }

            //console.log("pelmedsHcpOrderData " + JSON.stringify(pelmedsHcpOrderData));

            const { data } = await axios.post(pelmedsHcpOrderUrl, pelmedsHcpOrderData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

            if (data?.data?.status == false) {
                toast.error(data.data.message);
            }
            else {
                toast.success("Report Generated Successfully");
                const { blobUrl } = await createIframeReportBlobUrl(data);
                setIframeSrc(blobUrl);
            }
            showSpinner(false);
        }
        else {
            toast.error("Required Fields are empty");
        }

    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleHcpChange = e => {
        setFormData({
            ...formData,
            'hcp': e.value
        });
    };

    return (
        <div>
            <div style={{
                height: 0,
                overflow: 'hidden',
                // width: 0
            }}>
                {iframeSrc && (
                    <iframe
                        src={iframeSrc}
                        style={{ width: "100%", height: "500px", border: "none" }}
                        title="Preview Content"
                    />
                )}
            </div>
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Check
                                type="checkbox"
                                label="Show All HCP?"
                                name="isShowAllHCP"
                                onChange={(e) =>
                                    setFormData({ ...formData, isShowAllHCP: e.target.checked ? true : false })
                                }
                                checked={formData.isShowAllHCP}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label className="required">HCP</Form.Label>
                            <ThemedSelect
                                name="hcp"
                                closeMenuOnSelect={true}
                                placeholder='Select Individual'
                                classNamePrefix="react-select"
                                options={formData.isShowAllHCP ? allHcpOptions : hcpoptions}
                                getOptionLabel={option => option.key}
                                getOptionValue={option => option.value}
                                onChange={handleHcpChange}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        borderColor: "#ced4da",
                                        boxShadow: "none",
                                        "&:hover": { borderColor: "#80bdff" },
                                    }),
                                    option: (provided, { isFocused, isSelected }) => ({
                                        ...provided,
                                        backgroundColor: isSelected ? "#e9ecef !important" : isFocused ? "#f8f9fa !important" : "white !important",
                                        color: isSelected ? "#212529 !important" : "#212529 !important",
                                        cursor: "pointer",
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: "#212529",
                                    }),
                                }}
                            />
                            {hcpError && <div className="text-danger mt-1 small">Please select an HCP</div>}
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label className="required">Report Format</Form.Label>
                            <Form.Select
                                name="reportformat"
                                value={formData.reportformat}
                                // value={Number(localStorage.getItem("groupId")) == 52 ? '9' : formData.reportformat}
                                disabled={Number(localStorage.getItem("groupId")) == 52}
                                onChange={handleFieldChange}
                            >
                                {reportFormatOptions.map(option => {
                                    let isFacilitySelected = false;
                                    if (option.value == formData.reportformat) {
                                        isFacilitySelected = "selected";
                                    }
                                    return (
                                        <option key={option.value} value={option.value} selected={isFacilitySelected}>
                                            {option.label}
                                        </option>)
                                })}
                            </Form.Select>
                            {reportFormatError && <div className="invalid-feedback">Please select a report format</div>}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label>HCP Address</Form.Label>
                            <Form.Control
                                type="text"
                                name="hcpAddress"
                                value={formData.hcpAddress || ''}
                                onChange={handleFieldChange}
                                placeholder="Enter HCP address"
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Appointment Date</Form.Label>
                            <DatePicker
                                selected={formData.appointmentDate || null}
                                onChange={(date) => setFormData({ ...formData, appointmentDate: date })}
                                dateFormat="MM/dd/yy"
                                className="form-control"
                                placeholderText="Select Date"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Appointment Time</Form.Label>
                            <Form.Control
                                type="time"
                                name="appointmentTime"
                                value={formData.appointmentTime || ''}
                                onChange={handleFieldChange}
                            />
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label>Is this an Annual Physical?</Form.Label>
                            <div>
                                <Form.Check
                                    inline
                                    type="checkbox"
                                    label="Yes"
                                    name="isAnnualPhysicalYes"
                                    onChange={(e) =>
                                        setFormData({ ...formData, isAnnualPhysical: e.target.checked ? true : '' })
                                    }
                                    checked={formData.isAnnualPhysical === true}
                                />
                                <Form.Check
                                    inline
                                    type="checkbox"
                                    label="No"
                                    name="isAnnualPhysicalNo"
                                    onChange={(e) =>
                                        setFormData({ ...formData, isAnnualPhysical: e.target.checked ? false : '' })
                                    }
                                    checked={formData.isAnnualPhysical === false}
                                />
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group className="mb-3">
                            <Form.Label>Reason</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="reason"
                                value={formData.reason || ''}
                                onChange={handleFieldChange}
                                placeholder="Reason"
                            />
                            {/* {reasonError && <div className="text-danger mt-1 small">Please type an Reason</div>} */}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col></Col>
                    <Col>
                        <Form.Group>
                            {spinner && (
                                <Button variant="primary" disabled className="mt-3 w-100">
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    <span className="p-2" style={{ "verticalAlign": "3px" }}>Fetching...</span>
                                </Button>
                            )}
                            {!spinner && (
                                <Button
                                    type="submit"
                                    color="primary"
                                    className="mt-3 w-100">
                                    Generate
                                </Button>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                    </Col>
                </Row>
            </Form>
            <br />

        </div>
    );
};

HcpOrder.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

HcpOrder.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default HcpOrder;

